var lazy_status1=0;
var lazy_status2=0;

//判断语言的
function yuyan_sr()
{
	var yys=new Array("ja","ko");
	var y_url=location.href;
	var y_reg=new RegExp("en","i");
	var yy="";
	for(var i in yys)
	{
		y_reg=new RegExp("\/"+yys[i]+"\/","i");
		if(y_reg.test(y_url))
		{
			yy=yys[i]+"-";//
			dstatus=1;
			break;
		}
	}
	
	return yy;
}


 

function sr_lazy_loadimg(i)
{
	var obj=$(".sr-lazy-img"+i);
	var yy=yuyan_sr();
	var ysrc=yy+"src";
	obj.each(function(index,element){
		var str=$(element).data(ysrc);
		if(!str)
		{
			str=$(element).data("src");
		}
		
		if(str)
		{
			$(element).attr("src",str).hide().attr("onload","this.style.display='block'");
			 
		}
		
		
	});
	
	if(i==1)
	{
		lazy_status1=1;
	}
	else{
		lazy_status2=1;
	}
	
}

function init_lazy_imgs()
{
  var i=$(document).scrollTop();
  if(i>150 && lazy_status1==0)
  {
    lazy_status1=1;
    sr_lazy_loadimg(1);
  }
  else if(i>450 && lazy_status2==0)
  {
    lazy_status2=1;
    sr_lazy_loadimg(2);
  }
}

$(document).scroll(function(){
  init_lazy_imgs();
});
init_lazy_imgs();
